import { createFileRoute } from '@tanstack/react-router'
import { ResourcePage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/it/risorse/$resourceSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'resource', locale: 'it', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { resourceSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ResourcePage resourceSlug={resourceSlug} />
    </CatalogProvider>
  )
}
